import { defineComponent as _defineComponent } from 'vue'
import { StreamingChartInfo } from '@/@types/graphql-types';
import { computed } from 'vue';
import SingleRankingDisplay from '@/components/streaming-charts/SingleRankingDisplay.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailChartInfoV1',
  props: {
    streamingChartInfo: null
  },
  setup(__props: any) {

const props = __props as { streamingChartInfo: StreamingChartInfo };



const topRankString = computed(() => {
	return props.streamingChartInfo.topRank.toString().padStart(2, '0') + '.';
});

return { __sfc: true,props, topRankString, SingleRankingDisplay }
}

})